export const title = {
    'en': 'data mining',
    'zh-tw': '資料探勘'
};

export const setUpDataset = {
    'en': 'set up the dataset [dataset]',
    'zh-tw': '設定資料集[dataset]'
};

export const setUpData = {
    'en': 'Set training data [trainingDataPercent]% test data [testDataPercent]%',
    'zh-tw': '設定訓練資料[trainingDataPercent]% 測試資料[testDataPercent]%'
};

export const setFeatureColumns = {
    'en': 'set the feature columns [column] ',
    'zh-tw': '設定特徵欄位[column]'
};

export const setTargetPredictionColumn = {
    'en': 'set the target prediction column [column]',
    'zh-tw': '設定預測目標欄位[column]'
};

export const trainDecisionTreeModel = {
    'en': 'train a decision tree model',
    'zh-tw': '訓練決策樹模型'
};

export const visualizeDecisionTree = {
    'en': 'visualize the structure of the decision tree',
    'zh-tw': '繪製決策樹的結構'
};

export const setForecastField = {
    'en': 'predicted value for column [column]: [value]',
    'zh-tw': '預測欄位[column]值[value]'
};

export const predictedClass = {
    'en': 'predicted class',
    'zh-tw': '預測類別標籤'
};

export const forecastResult = {
    'en': 'forecast result',
    'zh-tw': '預測結果'
};

export const correctRate = {
    'en': 'correct rate',
    'zh-tw': '正確率'
};

export const evaluateDecisionTreeModel = {
    'en': 'evaluate decision tree model',
    'zh-tw': '評估決策樹模型'
};

export const dataset = {
    'en': 'dataset',
    'zh-tw': '資料集'
};

export const column = {
    'en': 'column',
    'zh-tw': '欄位名稱'
};

export const value = {
    'en': 'value',
    'zh-tw': '資料值'
};
